import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import DashboardLayout, {DashboardPage} from '../layout'
import { useData } from '../../../data'
import { useRouter } from '../../../routes'
import {trackPromise, usePromiseTracker} from 'react-promise-tracker'
import {Card, Row, Col, Table, Input, Form, Select, Popconfirm, Button, notification} from 'antd'
import { DeleteOutlined, UserOutlined, LockOutlined } from '@ant-design/icons';

const { Option } = Select;

/**
 * Jobs Dashboard page
 */
const DynamicJob = (props) => {
    const router = useRouter()
    const [form] = Form.useForm();
    const [segments, setSegments] = useState([]);
    const [toolList, setTools] = useState([])

    const data = useData()
    const jobs = data.jobs()
    const tools = data.tools()
    
    const layout = {
        labelCol: {
          span: 8,
        },
        wrapperCol: {
          span: 11,
        },
    };
      
    const columns = [
        {
          title: 'Column',
          dataIndex: 'column',
          key: 'column',
        },
        {
          title: 'Condition',
          dataIndex: 'condition',
          key: 'condition',
        },
        {
          title: 'Value',
          dataIndex: 'value',
          key: 'value',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (_, record) =>
            <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record)}>
                <a>Delete</a>
            </Popconfirm>
        },
    ];

    // get a list of tools to use 
    const getTools = async () => {
        try {
            const allTools = await tools.getAllTools()
            setTools(allTools.map(t => ({id: t.id, name: t.name, type: t.type, input_path: t.sample_input_file})))
        } catch (error) {
            console.log(error.message)
        }
        
    }

    /**
     * Get data required 
     */
    useEffect(() => {
        getTools()
        // eslint-disable-next-line
    }, [])

    //Add Item to segments
    const submitJob = (values) => {        
        const job_info = values
        job_info.segments = JSON.stringify(segments)
        job_info.type = 'manual'
        console.log(job_info);
        jobs.createDynamicJob(job_info)
            .then(data => {
                console.log(data)
                notification.success({
                    message: "Job creation started successfully."
                })
                router.push(`/dashboard/jobs`)
            })
            .catch(err => {
                console.log(err.message)
            })
    };

    //Add Item to segments
    const onFinish = (values) => {
        setSegments([...segments, values])
    };

    // Delete Item from segments
    const handleDelete = (record) => {
        const dataSource = segments;
        const newData = dataSource.filter((item) => {
            return (!(item.column == record.column && item.condition == record.condition));
        })
        setSegments(newData);
    };

    return (
        <DashboardLayout selected="dynamic_job" >
            <DashboardPage title="Create a Job" hasCta={false} >

                <Card title="Segments">
                    <Table dataSource={segments} columns={columns} pagination={false} />
                    <br/><br/>

                    <Form className="segment-form" form={form} name="horizontal_login" onFinish={onFinish}>
                        <Row>
                            <Col span={6} className="segment-input">
                                <Form.Item name="column" rules={[{ required: true, message: 'Please select your country!' }]} >
                                    <Select placeholder="Select Column">
                                        <Option value="number_of_employees">Company Size</Option>
                                        <Option value="geo">Location</Option>
                                        <Option value="funded">Funded</Option>
                                        <Option value="contacts">Contacts</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={6} className="segment-input">
                                <Form.Item name="condition" rules={[{ required: true, message: 'Please select your country!' }]}>
                                    <Select placeholder="Select Condition">
                                        <Option value="Equal To"> Equal To </Option>
                                        <Option value="Grater Than">Grater Than </Option>
                                        <Option value="Grater Than Equal">Grater Than Equal</Option>
                                        <Option value="Less Than">Less Than </Option>
                                        <Option value="Less Than Equal">Less Than Equal</Option>
                                        <Option value="Not Equal">Not Equal</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={7} className="segment-input">
                                <Form.Item name="value" rules={[{ required: true, message: 'Please input value!' }]}>
                                    <Input placeholder="Value" />
                                </Form.Item>
                            </Col>
                            <Col span={4} className="segment-input">
                                <Form.Item shouldUpdate>
                                    {() => (
                                        <Button type="primary" htmlType="submit" > Add </Button>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>

                    {/* Job form */}
                    <Form {...layout} className="segment-form" name="nest-messages" onFinish={submitJob}>
                        <Form.Item label="Select Tool" name="tool" rules={[{required: true, message: "Tool is required"}]}>
                            <Select placeholder="Select a tool">
                                {
                                    toolList.map(t => <Option value={t.id} key={t.id}>{t.id} - {t.name}</Option>)
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                        <Form.Item name='description' label="Description">
                            <Input.TextArea />
                        </Form.Item>
                        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
                            <Button type="primary" htmlType="submit">
                            Submit
                            </Button>
                        </Form.Item>
                    </Form>

                </Card>
    
            </DashboardPage>
        </DashboardLayout>
    )
}

export default DynamicJob
